import React from 'react';
export const CTA = () => {
  return <section className="py-24 bg-zinc-50 text-zinc-800 relative" data-id="element-46">
      <div className="absolute inset-0 bg-[radial-gradient(circle_at_center,rgba(59,166,159,0.15),transparent_50%)]" data-id="element-47"></div>
      <div className="container-custom relative z-10 max-w-4xl" data-id="element-48">
        <div className="text-center" data-id="element-49">
          <h2 className="font-serif text-4xl md:text-5xl mb-8 text-zinc-900" data-id="element-50">
            Ready to turn your AI vision into{' '}
            <span className="accent-text" data-id="element-51">reality?</span>
          </h2>
          <p className="text-zinc-600 text-lg mb-12 max-w-2xl mx-auto" data-id="element-52">
            Book a consultation with our team to discuss your AI product idea
            and learn how we can help you bring it to market rapidly.
          </p>
          <a href="http://calendly.com/es-lee" target="_blank" rel="noopener noreferrer" className="inline-block bg-zinc-800 text-white px-10 py-4 rounded-sm hover:bg-zinc-700 transition-colors text-lg" data-id="element-53">
            Book A Consultation
          </a>
          <p className="mt-8 text-zinc-500" data-id="element-54">
            Our team will respond within 24 hours to schedule your initial
            consultation.
          </p>
        </div>
      </div>
    </section>;
};